import Headroom from 'headroom.js'

/**
 * GlobalHeader functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class GlobalHeader {
/**
   * Constructs a new GlobalHeader instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */

  constructor(options) {
    this.element = options.element
    this.desktopNav = this.element.querySelector('nav[data-component="desktop"]')
    this.navItemsSubNav = this.desktopNav.queryAll('li.has-sub-navigation')
    this.navItemsSubNavLinks = this.desktopNav.queryAll('li.has-sub-navigation > a')
    this.globalHeader = document.querySelector('[data-component="global-header"]')
    this.navToggle = this.element.querySelector('[data-component="nav-toggle"]')
    this.mobileNav = this.element.querySelector('nav[data-component="mobile"]')

    this.navToggle.addEventListener('click', () => {
      this.globalHeader.classList.toggle('mobile-nav-visible')
      this.navToggle.classList.toggle('is-active')
    })

    this.navItemsSubNavLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
      })
    })

    this.navItemsSubNav.forEach(navItem => {
      navItem.addEventListener('mouseenter', () => {
        this.globalHeader.classList.add('is-hovered')
      })
      navItem.addEventListener('mouseleave', () => {
        this.globalHeader.classList.remove('is-hovered')
      })
    })

    var options = {
      offset: 0,
      tolerance: 0,
      classes: {
        initial: "headroom",
        pinned: "headroom--pinned",
        unpinned: "headroom--unpinned",
        top: "headroom--top",
        notTop: "headroom--not-top",
        bottom: "headroom--bottom",
        notBottom: "headroom--not-bottom",
        frozen: "headroom--frozen",
        pinned: "headroom--pinned foo bar"
      }
    }

    let headroom = new Headroom(this.element, options)
    headroom.init()

    const resizeWindow = () => {
      const headerHeight = this.element.getBoundingClientRect().height
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px')
    }

    resizeWindow()

    window.addEventListener('resize', resizeWindow, true)
    
  }
}
